import React, { Component } from 'react';
import { requestLogError } from '../../../services/uierror';
import { Card, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import error from "../../../assets/error.jpg";
const { Title, Text } = Typography;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    if (process.env.REACT_APP_ENVIRONMENT === 'LOCAL') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
      return;
    }
    // You can also log the error to an error reporting service
    requestLogError({
      error: error.message,
      componentStack: errorInfo,
    });
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: '#f5f5f5',
          }}
        >
          <Card
            style={{
              width: 420,
              textAlign: 'center',
              borderRadius: 12,
            }}
            bodyStyle={{ padding: '32px 24px' }}
          >
            {/* Icon */}
            <WarningOutlined style={{ fontSize: 48, color: '#ff4d4f' }} />

            {/* Image (optional) */}
            <div style={{ margin: '16px 0' }}>
              <img src={error} alt="error" height={180} />
            </div>

            {/* Heading */}
            <Title level={4} style={{ marginBottom: 8 }}>
              We're sorry...
            </Title>

            {/* Description */}
            <Text type="secondary">
              An error occurred while processing data
            </Text>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
